import * as Vue from "vue";
import {StoreManager} from "../../store";

enum RequestType {
  main, noAuth
}
export const requestInterceptorLoader = {

  load: () => {
    Vue.http.interceptors.push((request, next) => {

      let requestType = RequestType.main;

      if (request.url.includes("noAuthEndpoint") || request.url.includes("googleapis")) {
        requestType = RequestType.noAuth;
      }

      switch (requestType) {
        case RequestType.noAuth:
          request.headers.delete("Content-Type");
          request.headers.delete("Authorization");
          break;
        case RequestType.main:
          request.headers.set("Content-Type", "application/json");
          request.headers.set("Accept", "application/json");
          if (StoreManager.instance.store.state.session.token) {
            request.headers.set("Authorization", "bearer " + StoreManager.instance.store.state.session.token);
          }
      }

      next(response => response.ok ? Vue.$info(response.status, response.url, response) : Vue.$error("Request Error ", response.status, response.url, response));

    });
  }

};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helpers/interceptors/requestInterceptor.ts